import { FC, useEffect } from 'react';
import lodash from 'lodash';
import { useSnackbar } from 'notistack';
import { Button, CircularProgress } from '@mui/material';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { IOrderFetch } from 'src/models/IOrder';
import './styles.scss';

interface IProps {
  order: IOrderFetch;
}

const Transfer: FC<IProps> = ({ order }) => {
  const { id, handle_payments, prev_host, host } = order;

  const { transferPayment } = useActions();
  const { enqueueSnackbar } = useSnackbar();
  const { role } = useTypedSelector(state => state.auth);
  const isLoadingTransfer = useTypedSelector(state => state.order.isLoading.transfer);
  const resultTransfer = useTypedSelector(state => state.order.result.transfer);
  const lastTransfer = lodash.findLast(handle_payments, el => el.type === 'host_transfer');

  useEffect(() => {
    if (resultTransfer) {
      if (resultTransfer.status === 200) {
        enqueueSnackbar(resultTransfer.data, {
          variant: 'success'
        });
      } else if (resultTransfer.data) {
        enqueueSnackbar(resultTransfer.data, {
          variant: 'error'
        });
      }
    }
  }, [resultTransfer]);

  return (
    <div>
      <Button
        className='transfer'
        onClick={() => transferPayment(id)}
        disabled={!prev_host.length || (!!lastTransfer && lastTransfer.transfer_to === host.id)}
      >
        {isLoadingTransfer ? <CircularProgress size={15} /> : 'Except trip at this rate'}
      </Button>
    </div>
  );
};

export default Transfer;
